import React from "react";

// A block of "label · value" rows, used by the Spa and Network sections.
export const SpecGroup = ({ children }: { children: React.ReactNode }) => (
    React.Children.toArray(children).length === 0 ? null :
    <div className="sd-spec">
        <dl className="sd-spec-rows">{children}</dl>
    </div>
);

// V1 spas report far fewer fields than V2, so their pages leave out what never arrives
// instead of showing a label with nothing, or a made-up 0, beside it.
export const hasData = (value: unknown): boolean => value !== undefined && value !== null && value !== '';

export const SpecRow = ({ label, children, mono }: { label: string; children: React.ReactNode; mono?: boolean }) => (
    <div className="sd-spec-row">
        <dt>{label}</dt>
        <dd className={mono ? 'mono' : ''}>{children}</dd>
    </div>
);
